import React, { useState } from "react";

import { DropDown } from "../../components/Dashboard/DropDown/DropDown";
import { ReactComponent as MenuIcon } from "../../assets/menuIcon.svg";
import logo from "../../assets/logo.png";
import small_logo from "../../assets/small_logo.png";
import { Layout, Menu } from "antd";
import { useHistory } from "react-router-dom";
import {
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import "./AppLayout.css";

const { Header, Sider, Content } = Layout;

const AppLayout = ({ children, title }) => {
  const history = useHistory();
  const [collapsed, setCollapsed] = useState(false);

  const toggle = () => {
    setCollapsed(!collapsed);
  };

  return (
    <div className="layout_container">
      <Layout className="layout">
        <Sider
          className={!collapsed ? "layout_slider" : "layout_slider_2"}
          trigger={null}
          collapsible
          collapsed={collapsed}
        >
          <div className="logo">
            <img src={!collapsed ? logo : small_logo} alt="logo" />
          </div>
          <Menu
            className="layout_slider_menu"
            theme="dark"
            mode="inline"
            defaultSelectedKeys={["1"]}
          >
            <Menu.Item
              onClick={() => history.push("/")}
              className={
                !collapsed ? "ant_menu_item_opened" : "ant_menu_item_closed"
              }
              key="1"
              icon={<UserOutlined />}
            >
              Dashboard
            </Menu.Item>
            <Menu.Item
              onClick={() => history.push("/add-clients")}
              className={
                !collapsed ? "ant_menu_item_opened" : "ant_menu_item_closed"
              }
              key="2"
              icon={<VideoCameraOutlined />}
            >
              Add Client
            </Menu.Item>
            <Menu.Item
              onClick={() => history.push("/view-clients")}
              className={
                !collapsed ? "ant_menu_item_opened" : "ant_menu_item_closed"
              }
              key="3"
              icon={<VideoCameraOutlined />}
            >
              View Client
            </Menu.Item>
            <Menu.Item
              onClick={() => history.push("/view-clients")}
              className={
                !collapsed ? "ant_menu_item_opened" : "ant_menu_item_closed"
              }
              key="4"
              icon={<UploadOutlined />}
            >
              Income Report
            </Menu.Item>
            <Menu.Item
              className={
                !collapsed ? "ant_menu_item_opened" : "ant_menu_item_closed"
              }
              key="5"
              icon={<UserOutlined />}
            >
              Messages
            </Menu.Item>
            <Menu.Item
              className={
                !collapsed ? "ant_menu_item_opened" : "ant_menu_item_closed"
              }
              key="6"
              icon={<VideoCameraOutlined />}
            >
              Calendar
            </Menu.Item>
            <Menu.Item
              className={
                !collapsed ? "ant_menu_item_opened" : "ant_menu_item_closed"
              }
              key="7"
              icon={<UploadOutlined />}
            >
              Statistics
            </Menu.Item>
            <Menu.Item
              className={
                !collapsed ? "ant_menu_item_opened" : "ant_menu_item_closed"
              }
              key="8"
              icon={<VideoCameraOutlined />}
            >
              Prospective Clients
            </Menu.Item>
            <Menu.Item
              className={
                !collapsed ? "ant_menu_item_opened" : "ant_menu_item_closed"
              }
              key="9"
              icon={<UploadOutlined />}
            >
              Cases
            </Menu.Item>
          </Menu>
        </Sider>

        {/* First Sub Layout  */}
        <Layout className="site-layout">
          {/* Header */}
          <Header className="site-layout-background" style={{ padding: 0 }}>
            {React.createElement(collapsed ? MenuIcon : MenuIcon, {
              className: "trigger",
              onClick: toggle,
            })}
            <DropDown />
          </Header>

          {/* Section Header */}
          <Header className="site-layout-background-2">
            <h1>{title}</h1>
          </Header>

          {children}

          <p className="copyrights">Copyright &copy; 2020</p>
        </Layout>
      </Layout>
    </div>
  );
};

export default AppLayout;
